import { gql } from '@apollo/client'

export const GET_STORE_TYPES = gql`
  query StoreTypes($input: StoreTypesInput) {
    storeTypes(input: $input)
  }
`
